import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { starRating } from '@repo/pandacss/recipes';
import type { SystemStyleObject } from '@repo/pandacss/types';
import type { ComponentPropsWithRef, CSSProperties } from 'react';
export type StarRatingProps = ComponentPropsWithRef<'span'> & {
  css?: SystemStyleObject;
  value?: number;
};
export function StarRating(t0) {
  const $ = _c(14);
  let className;
  let cssProp;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      css: cssProp,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = cssProp;
    $[3] = props;
    $[4] = value;
  } else {
    className = $[1];
    cssProp = $[2];
    props = $[3];
    value = $[4];
  }
  if (!value) {
    return null;
  }
  let t1;
  if ($[5] !== className || $[6] !== cssProp) {
    t1 = cx(starRating(), css(cssProp), className);
    $[5] = className;
    $[6] = cssProp;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== value) {
    t2 = {
      "--star-rating-value": value
    };
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = t2 as CSSProperties;
  let t4;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t3) {
    t4 = <span aria-hidden={true} className={t1} style={t3} {...props} />;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}